import React from "react";
import { utils } from "@mc/mc-legacy";
import * as Enum from "../../api/StateInfo";
import MultiSelect from "../MultiSelect";

const StateFilterField = (props) => {
  const { ...componentProps } = props;
  const values = Enum.values.map((item) => ({
    id: item,
    title: Enum.getCaption(item),
  }));
  return <MultiSelect {...componentProps} values={values} storeMode={false} />;
};

export default StateFilterField;
